module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "df-verify"
  }, [_c('div', {
    staticClass: "main"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("重置你的密纹")]), _vm._v(" "), _c('el-form', {
    ref: "form",
    staticClass: "form c-form",
    attrs: {
      "rules": _vm.rules,
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "新密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "新密码至少6位",
      "type": "password"
    },
    model: {
      value: (_vm.form.password),
      callback: function($$v) {
        _vm.$set(_vm.form, "password", $$v)
      },
      expression: "form.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "确认密码",
      "prop": "password_confirmation"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请再次输入新密码",
      "type": "password"
    },
    model: {
      value: (_vm.form.password_confirmation),
      callback: function($$v) {
        _vm.$set(_vm.form, "password_confirmation", $$v)
      },
      expression: "form.password_confirmation"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticClass: "btn-pub publish",
    attrs: {
      "loading": _vm.isLoading,
      "disabled": _vm.isLoaded
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("重置密码")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-225ba7b3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/password/Verify.vue
// module id = 747
// module chunks = 2